<template>
  <section class="p-article1">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="cm-width c-pb-164 news-wrap">
        <section class="news-left">
          <div>
            <p class="c-fs-24 c-fw-b">QUAEE高颐和Zabbix达成战略合作 成为Zabbix中国区重要合作伙伴</p>
            <div class="c-mt-12 c-fs-16 c-c-text-grey">
              <span>2020-04-10 10:30</span><span class="c-ml-28">作者：猫维</span>
            </div>
          </div>
          <div class="c-mt-24 c-lh-28  content-wrap">
            <p>目前，Zabbix在大中华区合作伙伴已达到30家，如今仍在加速构建合作伙伴体系，以求为用户提供更加安全可靠的监控解决方案。</p>
            <p>随着数字业务规模不断扩大，线上的业务系统日益增多，核心业务越来越依赖IT系统的稳定运行。应用性能、服务器性能、网络性能、大量接口调用性能、容器等微服务组件性能、
              云平台性能等诸多因素都会影响业务运转及用户体验。因此，做好系统监控，提高运行效率，保障数据安全对于当下尤为重要。</p>
            <p>Zabbix是当今市场上最流行的监控解决方案之一。Zabbix的产品是自行开发并且开源，其高性能、可扩展性和久经考验的可靠性奠定其领先的市场地位。</p>
            <p>据了解，Zabbix目前已经发布了300+integrations解决方案 ，每年下载量4000000+。</p>
            <p>Zabbix不仅在全球发展迅猛，在大中华区也持续不断发展中。根据近年的年度下载量显示，中国占比近15%，以单个国家论，中国是全球每年下载量最大的国家。</p>
            <p>2020年4月10日，随着我们产品的稳步发展，以及功能和市场的高度服帖之后，我们与zabbix原厂签署合作伙伴协议，成为其中国区重要的合作伙伴之一，为中国更多客户提供更有高度、更智能、更全面的服务和支持。</p>
          </div>
          <div>
            <img src="../../assets/news/pic1.jpg" class="c-mt-24">
            <img src="../../assets/news/pic2.jpg" class="c-mt-48 c-w-100">
          </div>
        </section>
        <section class="news-right">
          <p class="c-fs-16 c-mb-16 c-fw-b">精选内容</p>
          <div>
            <p v-for="(item, index) in recommendList" :key="index" class="c-fs-12 c-cs-p c-mb-8 c-c-text-black c-ellipsis-1 news-link" @click="toUrl(item.url)">{{index + 1}}、{{item.title}}</p>
          </div>
          <div class="c-mt-48 c-mb-24 c-fs-12 c-c-text-black">
            <p class="c-fs-16 c-c-text-color c-mb-16 c-fw-b">联系我们</p>
            <p class="c-mb-8">安徽高颐科技有限公司</p>
            <p class="c-mb-8">地址：安徽省池州经济技术开发区电子信息产业园7楼</p>
            <p class="c-mb-8">电话：4006-111-696</p>
            <p>邮箱：joshua#quaee.com</p>
          </div>
          <img src="../../assets/header/QR-code1.png" class="code">
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width c-pb-40 news-wrap-mobile">
        <section class="news-left">
          <div>
            <p class="c-fs-19 c-fw-b">QUAEE高颐和Zabbix达成战略合作 成为Zabbix中国区重要合作伙伴</p>
            <div class="c-mt-12 c-fs-12 c-c-text-grey">
              <span>2020-04-10 10:30</span><span class="c-ml-28">作者：猫维</span>
            </div>
          </div>
          <div class="c-mt-24 c-fs-12 c-lh-18  content-wrap">
            <p>目前，Zabbix在大中华区合作伙伴已达到30家，如今仍在加速构建合作伙伴体系，以求为用户提供更加安全可靠的监控解决方案。</p>
            <p>随着数字业务规模不断扩大，线上的业务系统日益增多，核心业务越来越依赖IT系统的稳定运行。应用性能、服务器性能、网络性能、大量接口调用性能、容器等微服务组件性能、
              云平台性能等诸多因素都会影响业务运转及用户体验。因此，做好系统监控，提高运行效率，保障数据安全对于当下尤为重要。</p>
            <p>Zabbix是当今市场上最流行的监控解决方案之一。Zabbix的产品是自行开发并且开源，其高性能、可扩展性和久经考验的可靠性奠定其领先的市场地位。</p>
            <p>据了解，Zabbix目前已经发布了300+integrations解决方案 ，每年下载量4000000+。</p>
            <p>Zabbix不仅在全球发展迅猛，在大中华区也持续不断发展中。根据近年的年度下载量显示，中国占比近15%，以单个国家论，中国是全球每年下载量最大的国家。</p>
            <p>2020年4月10日，随着我们产品的稳步发展，以及功能和市场的高度服帖之后，我们与zabbix原厂签署合作伙伴协议，成为其中国区重要的合作伙伴之一，为中国更多客户提供更有高度、更智能、更全面的服务和支持。</p>
          </div>
          <div>
            <img src="../../assets/news/pic1.jpg" class="c-mt-24 c-w-100">
            <img src="../../assets/news/pic2.jpg" class="c-mt-24 c-w-100">
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
const recommendList = [{
  title: '第五届Zabbix峰会 中国深圳',
  url: '/article4'
}, {
  title: 'QUAEE高颐和Zabbix达成战略合作 成为Zabbix中国区重要合作伙伴',
  url: '/article1'
}, {
  title: 'Grafana如何助力Zabbix，打造漂亮的监控界面？',
  url: '/article2'
}
// {
//   title: '第五届Zabbix峰会中国站',
//   url: '/article3'
// }
]
export default {
  data () {
    return {
      recommendList: recommendList
    }
  },
  methods: {
    toUrl (url) {
      if (url) {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style lang="scss">
.p-article1 {
  .news-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 80px;
    .news-left {
      width: 70%;
      .content-wrap {
        p {
          margin-bottom: 20px;
        }
      }
    }
    .news-right {
      width: 26%;
      .news-link {
        &:hover {
          color: $text-blue;
        }
      }
      .code {
        width: 160px;
      }
    }
  }
  .news-wrap-mobile {
    .news-left {
      width: 100%;
      margin-top: 40px;
      .content-wrap {
        p {
          margin-bottom: 14px;
        }
      }
    }
  }
}
</style>
